import { createSlice } from "@reduxjs/toolkit";

const initialBrandsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  brands: [],
  exportStatus: null,
  exportURL: null,
  lastError: null,
  error: null,
  message: {
    error: null,
    success: null,
  },
  newMessage: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const brandsSlice = createSlice({
  name: "brands",
  initialState: initialBrandsState,
  reducers: {
    catchError: (state, action) => {
      // state.error = `${action.type}: ${action.payload.error}`;
      // state.messages.errorMessage = action.payload.error.response.data.message;
      state.message.error =
        action.payload.error.response && action.payload.error.response.data ? [...action.payload.error.response.data.errors] : action.payload.error.message;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message.success = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    saveBrands: (state, action) => {
      state.brands = action.payload
    },

    resetBrands: (state, action) => {
      state.brands = [];
    },

    resetStates: (state, action) => {
      state.listLoading = undefined;
      state.actionsLoading = undefined;
      state.totalCount = undefined;
      state.entities = null;
      state.exportStatus = null;
      state.exportURL = null;
      state.lastError = null;
      state.error = null;
      state.message = {
        error: null,
        success: null,
      };
      state.newMessage = null;
    },

    // findBrands
    brandsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    successActionCompleted: (state) => {
      state.message.success = null;
    },

    errorActionCompleted: (state) => {
      state.message.error = null;
    },
    // createBrand
    brandCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message.success = action.payload.message;

      state.entities = [action.payload.brand, ...state.entities];
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
    updateStatus: (state, action) => {
      const { status, url } = action.payload;
      state.exportStatus = status;
      state.exportURL = url;
    },
  },
});
